import { Currency } from "components/CustomCurrency/currency";
import { Unit } from "components/CustomUnits/units";
import MDTypography from "components/MDTypography";

export function formatData(data) {
  let _rows = [];
  let totalQuantity = 0;
  let totalSales = 0;
  data.forEach((elem) => {
    totalQuantity += elem.totalQuantity;
    totalSales += elem.totalSales;
    _rows.push({
      name: elem.productName.split("-")[0].trim(),
      presentation: elem.productPresentation,
      und: <Unit value={elem.totalQuantity} />,
      usd: <Currency value={elem.totalSales} />,
      collapse: elem.productName,
    });
  });
  return {
    columns: [
      { Header: "Nombre", accessor: "name" },
      { Header: "Presentación", accessor: "presentation" },
      {
        Header: (
          <>
            <div>{"UND (Total)"}</div>
            <div>
              <MDTypography variant="overline" color="dark" fontWeight="bold" textGradient>
                <Unit value={totalQuantity} />
              </MDTypography>
            </div>
          </>
        ),
        accessor: "und",
        width: "20%",
      },
      {
        Header: (
          <>
            <div>{"USD (Total)"}</div>
            <div>
              <MDTypography variant="overline" color="dark" fontWeight="bold" textGradient>
                <Currency value={totalSales} />
              </MDTypography>
            </div>
          </>
        ),
        accessor: "usd",
        width: "20%",
      },
    ],
    rows: _rows,
  };
}
